import { useState, useEffect } from 'react';
export const useElementIsVisible = (target, options = { threshold: 0.01 }) => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        if (!(target === null || target === void 0 ? void 0 : target.current))
            return undefined;
        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(target.current);
                }
            });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(target.current);
        return () => observer.disconnect();
    }, []);
    return isVisible;
};
